import { Colors } from '~/themes/colors';

interface ICardActionsHeaderProps {
  actions?: string[];
  isNewDesign?: boolean;
  rightOffset?: number;
}

export const CardActionsHeader = ({
  actions = [],
  isNewDesign,
  rightOffset,
}: ICardActionsHeaderProps) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      width: isNewDesign ? '100%' : 700,
      marginBottom: -12,
    }}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        marginRight: rightOffset ?? (isNewDesign ? 35 : 36),
        gap: isNewDesign ? 26 : 24,
      }}
    >
      {actions.map((action) => (
        <b
          key={action}
          style={{
            fontFamily: 'Nunito',
            color: Colors.primary_500,
            fontSize: 18,
            ...(isNewDesign && { width: 50, textAlign: 'center' as const }),
          }}
        >
          {action}
        </b>
      ))}
    </div>
  </div>
);
